import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col"
}
const _hoisted_2 = {
  key: 0,
  class: "icons-left"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "page" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "pages-count" }
const _hoisted_11 = {
  key: 0,
  class: "icons"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "col"
}
const _hoisted_16 = {
  key: 0,
  class: "icons"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]

import { computed, onMounted, ref, StyleValue, toRefs, watch } from "vue";
import { useControls } from "@/globals/components/PdfViewer/useControls";
import { getFont } from "@/helpers/fonts";
import { getIcon } from "@/helpers/api";
import { useDeviceStatus } from "@/stores/deviceStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'PdfControls',
  props: {
  isMove: { type: Boolean, default: false },
  isDownload: { type: Boolean, default: false },
  isDelete: { type: Boolean, default: false },
  page: { type: Number, default: 1 },
  pageCount: { type: Number, default: 1 },
  centerButtons: { type: Boolean, default: false },
  noShow: { type: Boolean, default: false },

  // NOVAS PROPS
  isZoomToHeight: { type: Boolean, default: false },
  isZoomToWidth: { type: Boolean, default: false },
  isPdf: { type: Boolean, default: false },
},
  emits: ["delete", "download", "next", "prev", "expand", "zoomToHeight", "zoomToWidth"],
  setup(__props) {

const props = __props;



const binIcon = ref<string>();
const downloadIcon = ref<string>();
const zoomToHeightIcon = ref<string>();
const zoomToWidthIcon = ref<string>();

const nore12 = ref<StyleValue>();
const leftArrow = ref<string>();
const rightArrow = ref<string>();
const expand = ref<string>();
const { isWeb } = toRefs(useDeviceStatus());

onMounted(async () => {
  nore12.value = (await getFont("nore12")) as StyleValue;
  expand.value = await getIcon("1602", "expand");

  leftArrow.value = await getIcon("1602", "previous_page");
  rightArrow.value = await getIcon("1602", "next_page");
  binIcon.value = await getIcon("2105", "bin");
  downloadIcon.value = await getIcon("2105", "download");
});

const isRightArrowGray = computed(() => props.page === props.pageCount);
const isLeftArrowGray = computed(() => props.page === 1);
computed(() => props.page === 1);
const currentPage = ref(props.page);

watch(
  () => props.page,
  (newPage) => {
    currentPage.value = newPage;
  }
);

return (_ctx: any,_cache: any) => {
  return (!__props.noShow)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['controls', { 'center-layout': __props.centerButtons }]),
        onPointerdown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
        onPointerup: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
        onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
      }, [
        (!__props.centerButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (false && (__props.isZoomToHeight || __props.isZoomToWidth))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (__props.isZoomToHeight)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: expand.value,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('zoomToHeight')))
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (__props.isZoomToWidth)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: leftArrow.value,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('zoomToWidth')))
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['col', 'col2', { 'center-icons': __props.centerButtons }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (__props.isZoomToHeight)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: zoomToHeightIcon.value,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('zoomToHeight')))
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (__props.isZoomToWidth)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: zoomToWidthIcon.value,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('zoomToWidth')))
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (__props.isPdf)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("img", {
                    src: leftArrow.value,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('prev'))),
                    style: _normalizeStyle({ opacity: isLeftArrowGray.value ? 0.3 : 1, pointerEvents: isLeftArrowGray.value ? 'none' : 'auto' })
                  }, null, 12, _hoisted_8),
                  _createElementVNode("img", {
                    src: rightArrow.value,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('next'))),
                    style: _normalizeStyle({ opacity: isRightArrowGray.value ? 0.3 : 1, pointerEvents: isRightArrowGray.value ? 'none' : 'auto' })
                  }, null, 12, _hoisted_9),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(nore12.value)
                    }, _toDisplayString(currentPage.value) + " / " + _toDisplayString(__props.pageCount), 5)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (__props.centerButtons && (__props.isDownload || __props.isDelete || __props.isMove))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (__props.isMove)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: expand.value,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('expand'))),
                      class: "expand-icon"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (__props.isDelete)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: binIcon.value,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('delete')))
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                (__props.isDownload)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: downloadIcon.value,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('download')))
                    }, null, 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (!__props.centerButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (__props.isDownload || __props.isDelete || _unref(isWeb) || __props.isMove)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (__props.isMove)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: expand.value,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('expand'))),
                          class: "expand-icon"
                        }, null, 8, _hoisted_17))
                      : _createCommentVNode("", true),
                    (__props.isDelete)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: binIcon.value,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('delete')))
                        }, null, 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (__props.isDownload)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: downloadIcon.value,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('download')))
                        }, null, 8, _hoisted_19))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 34))
    : _createCommentVNode("", true)
}
}

})